<div #body class="detail-page__body">
  <app-quick-nav #quicknav class="detail-page__nav" [toc]="toc"></app-quick-nav>
  <app-not-approved-header [notApproved]="isNotApproved"></app-not-approved-header>
  <div class="flying-club-detail__before-overview" *ngIf="isBusinessOwner || isAmbassador">
    <div class="flying-club-detail__edit-toggle">
      <app-edit-toggle *ngIf="isBusinessOwner || isAmbassador" class="editSlider"></app-edit-toggle>
      <div class="flying-club-detail__edit-help" *ngIf="isBusinessOwner || isAmbassador" (click)="showHelp()">Edit Mode Help</div>
    </div>
    <app-flight-deck-button class="flying-club-detail__flight-deck-button" *ngIf="editModeSet && (isFlightDeckAdmin || isAmbassador)" [(business)]="business"></app-flight-deck-button>
    <!-- <div class="business-detail__right-text"> </div> -->
  </div>

  <div class="detail-page__content">
    <div class="detail-page__primary">
      <div id="overview" class="detail-page__wrapper scroll-spy-section">
        <app-business-overview [business]="business"></app-business-overview>
      </div>

      <app-open-x-adunit [adUnitId]="'/21794231495/directory/leaderboard'" [width]="728" [height]="90" [position]="6"></app-open-x-adunit>

      <div class="detail-page__main">
        <div id="contacts" class="detail-page__wrapper scroll-spy-section">
          <app-contact [business]="business"></app-contact>
        </div>

        <div id="club" class="detail-page__wrapper scroll-spy-section">
          <app-flying-club [business]="business"></app-flying-club>
        </div>
      </div>
    </div>
    <div class="detail-page__rail">
      <app-associated-airports [business]="business"></app-associated-airports>

      <div class ="flying-club-detail__section-spacer"></div>

      <div class="detail-page__rail-content">
        <div class="section__right-rail">
          <div class="section__header">
            <h2 class="section__header-text">Business Reviews</h2>
          </div>
          <div class="section__body">
            <app-reviews [airport]=null [business]="business" (reloadThisEntity)="onReloadBusiness($event)"></app-reviews>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>
